
<div class="mb-dialog">
  <mb-dialog-body class="dialog-body">
    <div class="dialog-body__icon--mobile">
      <mb-icon icon="megaphone"> </mb-icon>
    </div>

    <div class="dialog-body__header">
      <h3>Pasó un rato desde tu última búsqueda.</h3>
      <mb-icon icon="x-close" (click)="closeDialog()"></mb-icon>
    </div>

    <img alt="" src="/hotels/dist/es-AR/browser/assets/images/rate-not-found.svg" />

    <p>
      Queremos asegurarnos de mostrarte las alternativas y tarifas actualizadas para que
      puedas seleccionar tu alojamiento.
    </p>
  </mb-dialog-body>
  <mb-dialog-footer>
    <button mb-button color="secondary" (click)="refreshPage()">Actualizar</button>
  </mb-dialog-footer>
</div>
